import { takeEvery, put, call, all } from 'redux-saga/effects';
import findIndex from 'lodash/findIndex';
import { getStores as getStoresFromOrders } from 'yoda-interfaces/lib/Order/OrderApi';
import { getZipCode } from 'yoda-interfaces/lib/Vendor/VendorApi';
import {
    FIND_STORES_SUCCESS,
    OPEN_FIND_STORES_SLIDE_PANEL,
} from 'yoda-site-components/lib/actionTypes/FindStoresActionTypes';
import showGlobalLoader from 'yoda-checkout-components/lib/actions/ShowGlobalLoaderAction';
import { GET_SHIPPABLE_STORES_FOR_PICKUP } from '../actionTypes/ShipToStoreActionTypes';

function* getShippableStoresSaga(action) {
    yield put(showGlobalLoader(true));

    const getStoresPayload = {};
    getStoresPayload.radius = action.payload.radius;
    getStoresPayload.pageSize = action.payload.pageSize;

    let address = '';
    let latitude = '';
    let longitude = '';
    let location = '';
    const { zipCode } = action.payload;
    if (zipCode) {
        if (!__SERVER__) {
            location = `${zipCode}`;
        } else {
            // TODO: Implement error message for this case
            yield put(showGlobalLoader(false));
            return;
        }
    } else {
        address = `${action.payload.latitude},${action.payload.longitude}`;
        latitude = `${action.payload.latitude}`;
        longitude = `${action.payload.longitude}`;
    }
    if (location) {
        getStoresPayload.location = location;
    } else {
        getStoresPayload.latitude = latitude;
        getStoresPayload.longitude = longitude;
    }

    getStoresPayload.xClientSource = 'CHECKOUT';

    // Calling v1 browse API to get exact store count
    const response = yield call(getStoresFromOrders, getStoresPayload);
    if (response.status === 200) {
        const storesData = {};
        // fix for zip code 11111 break
        if (response.data && response.data.page && response.data.page.length) {
            const currentPageIndex = findIndex(response.data.page, {
                selected: true,
            });
            const nextPage = response.data.page[currentPageIndex + 1];
            storesData.nextPageLink = nextPage && nextPage.url ? nextPage.url : '';
        }
        storesData.zipCode = zipCode || (yield call(getZipCode, { address }));
        storesData.miles = action.payload.radius;
        storesData.stores = response.data.stores;
        storesData.count = response.data && response.data.meta && response.data.meta.totalStores;
        yield all([
            put({ type: FIND_STORES_SUCCESS, payload: storesData }),
            put(showGlobalLoader(false)),
            put({ type: OPEN_FIND_STORES_SLIDE_PANEL }),
        ]);
    } else {
        const emptyStoresData = {
            zipCode,
            miles: getStoresPayload.radius,
            stores: [],
        };
        yield all([
            put({ type: FIND_STORES_SUCCESS, payload: emptyStoresData }),
            put(showGlobalLoader(false)),
            put({ type: OPEN_FIND_STORES_SLIDE_PANEL }),
        ]);
    }
}

const watchGetShippableStores = function* watchGetShippableStores() {
    yield takeEvery(GET_SHIPPABLE_STORES_FOR_PICKUP, getShippableStoresSaga);
};
watchGetShippableStores.sagaName = 'watchGetShippableStores';

// eslint-disable-next-line import/prefer-default-export
export { watchGetShippableStores };
